import React from 'react';
import {FaExternalLinkAlt} from "react-icons/fa";
import BaseNode from "./base-node.jsx";
import CheckHasData from "../check-has-data.jsx";
import {FaCircleInfo, FaShareNodes} from "react-icons/fa6";
import {Types} from "../enums.js";

const SocialMedia = ({ data, selected }) => {
    const title = () => {
        return (
            <>
                <p>
                    <b><CheckHasData value={data.socialMedia} /></b>
                </p>
            </>
        )
    }

    const icon = (<FaShareNodes size={16} color={"#031b34"}/>);

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            <div className={"flex items-center mb-1"}>
                <FaExternalLinkAlt/>
                <a href={data.value} target={"_blank"} className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                    {data.value}
                </a>
            </div>

            <div className={"flex"}>
                <div>
                    <FaCircleInfo />
                </div>
                <p className="mb-0 ml-1 text-[6px] overflow-hidden [display:-webkit-box] [-webkit-line-clamp:4] [-webkit-box-orient:vertical]">
                    <CheckHasData value={data.additionalValue} />
                </p>
            </div>
        </div>
    );

    return (
        <BaseNode
            icon={icon}
            title={title()}
            image={null}
            infoBlock={infoBlock}
            onSearchAll={() => {}}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#ef5744]"}
            bgBody={"bg-[#ffe8e8]"}
            type={Types.SOCIAL_MEDIA}
        />
    );
};

export default SocialMedia;